// App.jsx
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import MainPage from './pages/MainPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AddUserPage from './pages/AddUserPage';
import AdminAgreementTypesPage from './pages/AdminAgreementTypesPage';

import './styles/App.css';

const App = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="/add-user" element={<ProtectedRoute><AddUserPage /></ProtectedRoute>} />
      <Route path="/admin/agreement-types" element={<ProtectedRoute><AdminAgreementTypesPage /></ProtectedRoute>} />
    </Routes>
  </Router>
);

export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import MainPage from './pages/MainPage';
// import AdminPage from './pages/AdminPage';
// import LoginPage from './pages/LoginPage';
// import ProtectedRoute from './components/ProtectedRoute';
// import AddUserPage from './pages/AddUserPage'; // ✅ import the page
// import AdminAgreementTypesPage from './pages/AdminAgreementTypesPage';


// import './styles/App.css';

// const App = () => (
//   <Router>
//     <Routes>
//       {/* Only public page */}
//       <Route path="/login" element={<LoginPage />} />

//       {/* All other pages require login */}
//       <Route
//         path="/"
//         element={
//           <ProtectedRoute>
//             <MainPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin"
//         element={
//           <ProtectedRoute>
//             <AdminPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/add-user"
//         element={
//           <ProtectedRoute>
//             <AddUserPage />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/admin/agreement-types"
//         element={
//           <ProtectedRoute>
//             <AdminAgreementTypesPage />
//           </ProtectedRoute>
//         }
//       />
//     </Routes>
//   </Router>
// );

// export default App;
